<template>
  <div class="spinner" />
</template>

<style lang="scss" scoped>
  .spinner {
    border-radius: 50%;
    border: 2px solid;
    border-color: #1c1e22;
    border-right-color: #dbdcef;
    animation: spin 1s infinite linear;
  }

  @keyframes spin {
    to {
      transform: rotate(1turn);
    }
  }
</style>
